(function (arr) {
    // if (!import.meta.env.LEGACY) return;
    arr.forEach(function (item) {
        if (item.hasOwnProperty("before")) {
            return;
        }
        Object.defineProperty(item, "before", {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function before() {
                var _a;
                var argArr = Array.prototype.slice.call(arguments), docFrag = document.createDocumentFragment();
                argArr.forEach(function (argItem) {
                    var isNode = argItem instanceof Node;
                    docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
                });
                (_a = this.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(docFrag, this);
            },
        });
    });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);
export {};
